

class Column {
  get defaultSort() {
    return false;
  }

  get id() {
    return undefined;
  }

  get isConfigurable() {
    return true;
  }

  get title() {
    return 'Unknown';
  }

  get visible() {
    return true;
  }

  sortAscending(a, b) {
    if (a.id < b.id) {
      return -1;
    }
    if (a.id > b.id) {
      return 1;
    }
    return 0;
  }

  sortDescending(a, b) {
    if (a.id < b.id) {
      return 1;
    }
    if (a.id > b.id) {
      return -1;
    }
    return 0;
  }
}


/**
 * returns either `null`/`'ascending'`/`'descending'` indicating whether the
 * current sort is for the column, and whether it's ascending or descending.
 */
var isColumnSorted = function(sortOption, columnId) {
  var result = undefined;

  if (sortOption) {
    if (sortOption.startsWith(columnId)) {
      if (sortOption.endsWith('+')) {
        result = 'ascending';
      }
      if (sortOption.endsWith('-')) {
        result = 'descending';
      }
    }
  }


  return result;
}


/**
 * Returns true/false indicating whether the column should be shown
 */
var showColumn = function(columnSetting, column) {
  // the default is set by the column
  var result = column.visible;

  // the setting can override that and show/hide the field
  if (columnSetting) {
    if (columnSetting.indexOf(column.id + '-') > -1) {
      result = false;
    }
    if (columnSetting.indexOf(column.id + '+') > -1) {
      result = true;
    }
  }

  return result;
}


/**
 * Returns the sort method that should be used for sorting the table based on
 * the sorting option, and the shown columns
 */
var getSortMethod = function(sortOption, columns) {
  var result = undefined;

  for (var i = 0; i < columns.length; i++) {
    var column = columns[i];

    if (sortOption == column.id + '+') {
      result = column.sortAscending;
      break;
    }
    if (sortOption == column.id + '-') {
      result = column.sortDescending;
      break;
    }

    // set the default sort method, in case one is not set
    if (column.default) {
      result = column.sortDescending;
    }
  }


  return result;
};


export default Column;

export { getSortMethod, isColumnSorted, showColumn };

